import React, { useCallback, useEffect } from 'react';
import { array, bool, func, shape, string } from 'prop-types';

import { groupBy } from 'lodash';

import useApi from '../../hooks/useApi';
import template from 'url-template';

import TagSelect from '../../components/FormFields/TagSelect';

const BusinessTypesUrl = template.parse('/business-types{?limit}');
const ClientsUrl =
    template.parse('/companies/{companyId}/clients{?limit,sort}');
const LIMIT = 10000;
const SORT = 'name^asc';

const ClientsSelectFilter = ({
    companyId,
    disabled,
    clientsFilter,
    onChangeClientsFilter,
    ...props
}) => {
    const [businessTypes, getBusinessTypes] = useApi(() => ({
        url: BusinessTypesUrl.expand({ limit: LIMIT })
    }));
    const [clients, getClients] = useApi(() => ({
        url: ClientsUrl.expand({
            companyId,
            limit: LIMIT,
            sort:  SORT
        })
    }));

    useEffect(() => {
        getBusinessTypes();
        getClients();
        return () => {
            businessTypes.cancel();
            clients.cancel();
        };
    }, []);

    const changeHandler = (defaultValues = {}) => {
        return (event) => {
            const { value } = event.target;
            const groupedValues = groupBy(value, 'type');
            const newValues = { ...defaultValues };
            Object.entries(groupedValues).forEach(([type, value]) => {
                newValues[type] = value;
            });
            onChangeClientsFilter(newValues);
        };
    };

    const handleChange = useCallback(
        changeHandler({
            clients:       [],
            businessTypes: []
        })
    );

    const options = [
        {
            error:     businessTypes.error,
            isLoading: businessTypes.loading,
            items:     businessTypes.data,
            name:      'Business Types',
            itemProps: {
                type: 'businessTypes'
            }
        },
        {
            error:     clients.error,
            isLoading: clients.loading,
            items:     clients.data,
            name:      'Clients',
            itemProps: {
                type: 'clients'
            }
        }
    ];

    const value = [...clientsFilter.businessTypes, ...clientsFilter.clients];

    return (
        <TagSelect
            disabled={disabled}
            grouped
            kickerText="Add any combination of Business Types or Specific Clients to filter by these items."
            label="Clients"
            name={undefined}
            onChange={handleChange}
            options={options}
            placeholder="Add Clients"
            value={value}
            {...props}
        />
    );
};

ClientsSelectFilter.defaultProps = {
    clientsFilter: {
        businessTypes: [],
        clients:       []
    },
    companyId:             '',
    disabled:              false,
    onChangeClientsFilter: () => {}
};

ClientsSelectFilter.propTypes = {
    clientsFilter: shape({
        businessTypes: array.isRequired,
        clients:       array.isRequired
    }),
    companyId:             string.isRequired,
    disabled:              bool,
    onChangeClientsFilter: func.isRequired
};

export default ClientsSelectFilter;
